import axios from 'axios';

export const authApi = axios.create({ baseURL: '/auth-api' });
